import React from "react"
import {FieldQuickFilterViewProps} from "../../render/quick-filter-view";

export default function FieldProto_QuickFilterView(props: FieldQuickFilterViewProps) {

    return (
        <div className="ui5-txt-default ui5-txt-red">{props.field.type}.quickFilterView</div>
    )

}